module.exports = __webpack_public_path__ + "img/img4.c9aef622.jpg";